// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05730fb6","453":"a06f6574","455":"6bef7f89","977":"7d5ee54a"}[chunkId] + ".chunk.js";
};